export enum PermissionLevel {
  NONE = 0,
  ADVISOR = 1,
  MANAGER = 2,
  ADMINISTRATOR = 3
}